import { createSaga } from './saga-helpers';

import * as Api from '../api/tasks-api';

const watchGetTasks = createSaga({
    type: 'TASKS_FETCH',
    fn: Api.fetchTasks,
    args: action => [action.payload],
    successPayload: ({ tasks, hasMore } = {}, action) => ({
        tasks,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchArchiveTasks = createSaga({
    type: 'TASKS_ARCHIVE',
    fn: Api.archiveTasks,
    args: action => [action.payload.taskIds]
});

const watchCompleteTasks = createSaga({
    type: 'TASKS_COMPLETE',
    fn: Api.completeTasks,
    args: action => [action.payload.taskIds]
});

const watchCreateTask = createSaga({
    type: 'TASK_CREATE',
    fn: Api.createTask,
    args: action => [action.payload.task],
    successPayload: ({ id: taskId, order, nice_id, assignees, due_date, milestone }, action) => ({
        taskId,
        order,
        nice_id,
        assignees,
        due_date,
        milestone,
        fragment: action.payload.task
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.task
    })
});

const watchGetTask = createSaga({
    type: 'TASK_FETCH',
    fn: Api.fetchTask,
    args: action => [action.payload.taskId],
    successPayload: task => ({ task }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        taskId: action.payload.taskId
    })
});

const watchUpdateTask = createSaga({
    type: 'TASK_UPDATE',
    fn: Api.updateTask,
    args: action => [action.payload.taskId, action.payload.taskProps],
    successPayload: task => ({ task })
});

const watchMoveTask = createSaga({
    type: 'TASK_MOVE',
    fn: Api.moveTask,
    args: action => [action.payload.taskId, action.payload.moveProps],
    successPayload: task => ({ task })
});

const watchRemoveTask = createSaga({
    type: 'TASK_REMOVE',
    fn: Api.removeTask,
    args: action => [action.payload.taskId]
});

const watchRemoveArchivedTasks = createSaga({
    type: 'ARCHIVED_TASKS_REMOVE',
    fn: Api.removeArchivedTasks,
    args: action => [action.payload.projectId]
});

const watchAssignUsers = createSaga({
    type: 'TASK_ASSIGN',
    fn: Api.assignUsers,
    args: action => [action.payload.taskId, action.payload.assignees]
});

const watchUnassignUsers = createSaga({
    type: 'TASK_UNASSIGN',
    fn: Api.unassignUsers,
    args: action => [action.payload.taskId, action.payload.assignees]
});

const watchSetVisibility = createSaga({
    type: 'TASK_VISIBILITY_SET',
    fn: Api.setVisibility,
    args: action => [action.payload.taskId, action.payload.visible, action.payload.roles]
});

const watchAddTaskLabels = createSaga({
    type: 'TASK_LABELS_ADD',
    fn: Api.addTaskLabels,
    args: action => [action.payload.taskId, action.payload.labels]
});

const watchRemoveTaskLabel = createSaga({
    type: 'TASK_LABEL_REMOVE',
    fn: Api.removeTaskLabel,
    args: action => [action.payload.taskId, action.payload.labelId]
});

const watchAddTaskDoc = createSaga({
    type: 'TASK_DOC_ADD',
    fn: Api.addTaskDoc,
    args: action => [action.payload.taskId, action.payload.docId]
});

const watchRemoveTaskDoc = createSaga({
    type: 'TASK_DOC_REMOVE',
    fn: Api.removeTaskDoc,
    args: action => [action.payload.taskId, action.payload.docId]
});

export default [watchGetTasks, watchArchiveTasks, watchCompleteTasks, watchCreateTask, watchGetTask, watchUpdateTask, watchMoveTask, watchRemoveTask, watchRemoveArchivedTasks, watchAssignUsers, watchUnassignUsers, watchSetVisibility, watchAddTaskLabels, watchRemoveTaskLabel, watchAddTaskDoc, watchRemoveTaskDoc];
